import { render, staticRenderFns } from "./InboxPage.vue?vue&type=template&id=718c62e2&scoped=true"
import script from "./InboxPage.vue?vue&type=script&lang=js"
export * from "./InboxPage.vue?vue&type=script&lang=js"
import style0 from "./InboxPage.vue?vue&type=style&index=0&id=718c62e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c62e2",
  null
  
)

export default component.exports